"use client";

import { Localite, ProductServicePageBlock } from "@/payload-types";
import { RenderLocalityBlock } from "./RenderLocalityBlock";
import { RenderCategoryLocalityBlock } from "./RenderCategoryLocalityBlock";

export default function LocalitesPage({
  page,
  slug,
}: {
  page: Localite["layout"];
  slug: string[];
}) {
  return (
    <>
      {slug.length > 3 ? (
        <RenderLocalityBlock {...(page[0] as ProductServicePageBlock)} />
      ) : (
        <RenderCategoryLocalityBlock
          {...(page[0] as ProductServicePageBlock)}
        />
      )}
    </>
  );
}
